import { authBinaryFetch, authFetch, convertToJson, createForm, jsonFetch } from "utils";
import denormalize from "utils/denormalizers/proposal";

export const get = (proposalToken) =>
  jsonFetch(`${apiUrl}${version}/proposals/${proposalToken}`, {
    method: "GET",
  });

export const getAll = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/proposals`, {
    method: "GET",
  });

export const remove = (id) =>
  authFetch(`${apiUrl}${version}/proposals/${id}`, {
    method: "DELETE",
  });

export const create = (proposal) =>
  authBinaryFetch(`${apiUrl}${version}/deals/${proposal.deal.id}/proposals`, {
    method: "POST",
    body: createForm({ proposal: denormalize(proposal) }),
  }).then((res) => convertToJson(res));

export const update = (proposal) =>
  authBinaryFetch(`${apiUrl}${version}/proposals/${proposal.id}`, {
    method: "PUT",
    body: createForm({ proposal: denormalize(proposal) }),
  }).then((res) => convertToJson(res));

export const accept = (proposalToken, params) =>
  jsonFetch(`${apiUrl}${version}/proposals/${proposalToken}/accept`, {
    method: "POST",
    json: params,
  });
